const o=50;export{o as PLAY_BUTTON_HIDE_DEALY};
//# sourceMappingURL=constants.js.map
